// Angular Import
import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-nav-search',
  templateUrl: './nav-search.component.html',
  styleUrls: ['./nav-search.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class NavSearchComponent {
  // public props
  searchOn = false;
}
